<template>
    <section>
        <div class="background-section-title">
            <div class="section-title">
                <h2>Transcrições (Beta)</h2>
            </div>
        </div>
        <div class="section-content">
            <div class="list-container">
                <div class="vld-parent">
                    <loading :active.sync="isLoading"
                             :can-cancel="false"
                             :is-full-page="fullPage"></loading>
                </div>
                <div class="header-container shadow-sm p-3 mb-5 bg-white rounded">
                    <b-button class="new-user-button" @click="newTranscription()">
                        Nova transcrição
                    </b-button>
                    <b-form-radio-group
                            v-model="selected"
                            class="search-filter"
                            button-variant="outline-primary"
                            buttons
                    >
                        <b-form-radio value="name" v-b-tooltip.hover title="Nome da transcrição">Nome</b-form-radio>
                        <b-form-radio value="content" v-b-tooltip.hover title="Conteúdo">Conteúdo</b-form-radio>
                        <b-form-radio value="date" v-b-tooltip.hover title="Formato aceito: 15(dia), 2020, 15/01/2020">Data</b-form-radio>
                    </b-form-radio-group>
                    <div class="search-container">
                        <b-input-group size="sm" class="mb-0">
                            <b-input-group-prepend is-text>
                                <b-icon icon="search"></b-icon>
                            </b-input-group-prepend>
                            <b-form-input v-model="filterText" type="search" v-on:keyup.enter="onSearchClick()" placeholder="Buscar..."></b-form-input>
                        </b-input-group>
                    </div>
                </div>
                <b-table striped class="shadow-sm bg-white rounded" :fields="fields" :items="transcripts" :per-page="0" :current-page="currentPage" stacked="md">
                    <template v-slot:cell(name)="row">
                        <div>{{row.value}}</div>
                        <div v-if="row.item.content" style="font-family: Arial"><i> {{formatSearchedText(row.item.content)}} </i></div>
                    </template>
                    <template v-slot:cell(status)="row">
                        <img :src="getStatusIconStyle(row.item)"  v-b-tooltip.hover :title="getStatusIconTooltip(row.item)">
                    </template>
                    <template v-slot:cell(edit)="row">
                        <img class="item-table" :class="{ disabled: getStatus(row.item) }" :src="editIcon" @click="openTranscriptionDetail(row.item, row.index, $event.target)">
                    </template>
                    <template v-slot:cell(remove)="row">
                        <img class="item-table" :class="{ disabled: getStatus(row.item) }" :src="deleteIcon" @click="deleteTranscription(row.item, row.index, $event.target)">
                    </template>
                </b-table>
                <div class="pagination-container shadow-sm bg-white rounded">
                    <b-row>
                        <b-col class="my-3">
                            <b-pagination @input ="updatePage()" v-model="currentPage" :total-rows="totalRows" :per-page="perPage"></b-pagination>
                        </b-col>
                        <b-col  class="my-3">
                            <b-form-select @input ="updatePage()" style="min-width: 100px" id="per-page-select" v-model="perPage" :options="pageOptions"></b-form-select>
                        </b-col>
                    </b-row>
                </div>
            </div>
            <NewTranscription ref="newTranscriptionModal" @startTimer="startTimer" @loadTranscripts="loadTranscripts($event)"/>
        </div>
    </section>
</template>

<script>
  import { transcriptionService } from '../services/transcription.service';
  import { mapState, mapActions } from 'vuex';
  import Loading from 'vue-loading-overlay';
  import deleteIcon from '@/assets/icons/delete.svg';
  import editIcon from '@/assets/icons/pencil.svg';
  import transcribingIcon from '@/assets/icons/transcribing.svg';
  import doneIcon from '@/assets/icons/done.svg';
  import errorIcon from '@/assets/icons/erro_triangle.svg';
  import timeIcon from '@/assets/icons/pending.svg';
  import 'vue-loading-overlay/dist/vue-loading.css';
  import moment from 'moment';
  import { serverURL } from '../helpers/server';
  import NewTranscription from './Transcriptions/NewTranscriptions';

  export default {
    components: {
      Loading,
      NewTranscription
    },
    data () {
      return {
        transcribingIcon,
        doneIcon,
        errorIcon,
        timeIcon,
        deleteIcon,
        editIcon,
        transcripts: [],
        pageInfo: {},
        pageOptions: [5, 10, 15, { value: 100, text: 'Mostrar 100' }],
        fields: [
          {
            key: 'name',
            label: 'Nome',
            sortable: true,
            formatter: (value, key, item) => {
              return (value.length > 80) ? value.substr(0, 80) + '...' : value;
            }
          },
          {
            key: 'date.created',
            label: 'Data',
            sortable: true,
            formatter: (value, key, item) => {
              return moment(Number(value)).format('DD/MM/YYYY');
            },
            thStyle: { width: '220px' }
          },
          {
            key: 'status',
            label: 'Status',
            alias: 'status',
            sortable: false,
            thStyle: { width: '150px' }
          },
          { key: 'edit', label: '', sortable: false, thStyle: { width: '50px' } },
          { key: 'remove', label: '', sortable: false, thStyle: { width: '50px' } }
        ],
        isLoading: false,
        fullPage: true,
        timer: '',
        selected: 'name',
        filterText: '',
        refreshTimer: 15000,
        totalRows: 0,
        perPage: 15,
        currentPage: 1,
        mounted: false
      };
    },
    computed: {
      ...mapState({
        account: state => state.account
      })
    },
    mounted () {
      this.mounted = true;
    },
    async created () {
      await this.loadTranscripts({ perPage: parseInt(this.perPage), currentPage: this.currentPage });
      this.timer = setInterval(this.autoRefresh, this.refreshTimer);
    },
    beforeDestroy () {
      clearInterval(this.timer);
    },
    methods: {
      ...mapActions('account', ['balance']),
      async loadTranscripts (params) {
        this.isLoading = true;
        await this.loadTranscriptsWithoutLoading(params);
        this.isLoading = false;
      },
      async loadTranscriptsWithoutLoading (params) {
        if (params.date && params.date.isValid()) {
          params.date = params.date.unix();
        } else if (params.date && !params.date.isValid()) {
          if (/^\d{4}$/.test(this.filterText) && parseInt(this.filterText) >= 1900 && parseInt(this.filterText) <= 2100) {
            params.date = moment().year(parseInt(this.filterText)).startOf('year').unix();
            params.endDate = moment().year(parseInt(this.filterText)).endOf('year').unix();
          } else {
            this.transcripts = 0;
            this.pageInfo = 0;
            this.totalRows = 0;
            return;
          }
        }
        const result = await transcriptionService.getMetadataTranscriptions(params);

        if (result) {
          this.transcripts = result.transcripts;
          this.pageInfo = result.pageInfo;
          this.totalRows = this.pageInfo && this.pageInfo.length > 0 && this.pageInfo[0].count;
        }
      },
      async autoRefresh () {
        await this.balance();
        const params = { perPage: parseInt(this.perPage), currentPage: this.currentPage };

        await this.loadTranscriptsWithoutLoading(params);
      },
      formatSearchedText (content) {
        return content.replace(this.filterText, `"${this.filterText}"`);
      },
      updatePage () {
        if (this.mounted) {
          this.loadTranscripts({ perPage: parseInt(this.perPage), currentPage: this.currentPage });
        }
      },
      onSearchClick () {
        if (this.mounted) {
          if (this.selected === 'name' && this.filterText.length > 2) {
            clearInterval(this.timer);
            this.loadTranscripts({ perPage: parseInt(this.perPage), currentPage: parseInt(this.currentPage), name: this.filterText.toLowerCase() });
          } else if (this.selected === 'date' && this.filterText.length > 1) {
            clearInterval(this.timer);
            this.loadTranscripts({ perPage: parseInt(this.perPage), currentPage: parseInt(this.currentPage), date: moment(this.filterText, 'DD/MM/YYYY HH:mm') });
          } else if (this.selected === 'content' && this.filterText.length > 1) {
            clearInterval(this.timer);
            this.loadTranscripts({ perPage: parseInt(this.perPage), currentPage: parseInt(this.currentPage), content: this.filterText.toLowerCase() });
          } else {
            this.startTimer();
            this.loadTranscripts({ perPage: parseInt(this.perPage), currentPage: parseInt(this.currentPage) });
          }
        }
      },
      startTimer () {
        this.timer = setInterval(this.autoRefresh, this.refreshTimer);
      },
      getStatusIconStyle (transcription) {
        if (transcription.status === 'completed') {
          return this.doneIcon;
        } else if (transcription.status === 'transcribing') {
          return this.transcribingIcon;
        } else if (transcription.status === 'failed' || transcription.status === 'error') {
          return this.errorIcon;
        } else if (transcription.status === 'waiting' || transcription.status === 'pending' || transcription.status === 'receiving') {
          return this.timeIcon;
        }
      },
      getStatus (transcription) {
        if (transcription.status === 'completed') {
          return false;
        }
        return true;
      },
      getStatusIconTooltip (transcription) {
        if (transcription.status === 'completed') {
          return 'Finalizada';
        } else if (transcription.status === 'transcribing') {
          return 'Transcrevendo...';
        } else if (transcription.status === 'failed' || transcription.status === 'error') {
          return 'Falhou';
        } else if (transcription.status === 'waiting' || transcription.status === 'pending' || transcription.status === 'receiving') {
          return 'Pendente';
        }
      },
      async newTranscription () {
        const permissions = this.$store.state.account.permissions;
        if (permissions && !permissions.includes('SOLICITAR_TRANSCRICAO')) {
          this.$toast.open({ message: 'Usuário não possui permissão!', type: 'error' });
          return;
        }

        clearInterval(this.timer);
        this.$refs.newTranscriptionModal.showModal();
      },
      async deleteTranscription (transcription) {
        clearInterval(this.timer);
        this.$bvModal.msgBoxConfirm(`Tem certeza que deseja remover ${transcription.name} ?`, {
          size: 'md',
          buttonSize: 'md',
          okVariant: 'primary',
          okTitle: 'Excluir',
          cancelTitle: 'Cancelar',
          footerClass: 'p-2',
          headerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        }).then(async (value) => {
          if (value) {
            this.isLoading = true;
            const res = await transcriptionService.deleteTranscription(transcription.id);
            if (res.status === 200) {
              this.$toast.open('Transcrição removida com sucesso!');
              await this.loadTranscripts({ perPage: parseInt(this.perPage), currentPage: this.currentPage });
            } else if (res.status === 403) {
              this.isLoading = false;
              this.$toast.open({ message: 'Não é possivel remover essa transcrição!', type: 'error' });
            }
          }
        }).catch((err) => {
          this.$toast.open({ message: 'Falha ao remover!', type: 'error' });
          console.log(err);
        });
        this.isLoading = false;
        this.$refs.newTranscriptionModal.resetModal();
      },
      async openTranscriptionDetail (transcription) {
        if (transcription.status === 'completed') {
          this.isLoading = true;
          const transcriptionInfo = await transcriptionService.getTranscription(
            transcription.id
          );
          const metadata = await transcriptionService.getTranscriptionMetadata(
            transcription.id
          );
          const autoSpeakers = await transcriptionService.getTranscriptionSpeakers();

          transcriptionInfo.transcription.channels = metadata.channels;
          this.isLoading = false;
          this.$router.push({
            name: 'Editor',
            params: {
              transcription: transcriptionInfo.transcription,
              name: transcription.name,
              duration: transcription.duration,
              autoSpeakers: autoSpeakers,
              mediaPath: `${serverURL()}/stt/v1/transcript/${transcription.id}/media/stream?cookie=${this.account.user.token}`,
              wavePath: `${serverURL()}/stt/v1/transcript/${transcription.id}/media/wave?cookie=${this.account.user.token}`,
              savePath: `${serverURL()}/stt/v1/transcript/${transcription.id}/transcription?cookie=${this.account.user.token}`,
              preferencesPath: `${serverURL()}/stt/v1/transcript/preferences?cookie=${this.account.user.token}`,
              propertiesPath: `${serverURL()}/stt/v1/transcript/${transcription.id}/metadata?cookie=${this.account.user.token}`,
              exportAudioPath: `${serverURL()}/stt/v1/transcript/${transcription.id}/exportaudio?cookie=${this.account.user.token}`,
              exportHtmlPath: `${serverURL()}/stt/v1/transcript/${transcription.id}/exporthtml?cookie=${this.account.user.token}`,
              updateSpeakersPath: `${serverURL()}/stt/v1/transcript/speakers?cookie=${this.account.user.token}`
            }
          });
        } else {
          this.$toast.open({ message: 'Não é possivel editar a transcrição!', type: 'error' });
        };
      }
    }
  };
</script>

<style lang="scss" scoped>
    .disabled {
        pointer-events: none;
        opacity: 0.5;
        &:hover {
            background-color: #b5dcb1;
            transition: background-color 0.2s linear;
        }
    }
    .section-title {
      justify-content: space-between;
    }
    .section-content {
        display: 1;

        .list-container {
            margin-left: 20px;
            margin-right: 20px;
            flex: 1;

            .header-container {
                height: 50px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                background: #F5F8FA;
                border-radius: 4px;

                .search-container {
                    margin-right: 4%;
                }
            }

            .btn-custom {
                background-color: #bee7bd00;
                display: flex;
                border: 1px;
                margin-left: auto;
                margin-right: 0;
            }

            .item-table {
                border: none !important;
                background-color: none;
                cursor: pointer;
            }
        }

        .table {
            margin-top: 15px;
            background-color: #FFFFFF;
            border-radius: 4px;
            margin-bottom: 0px;
            /deep/thead th {
                font-family: Poppins;
                font-size: 14px;
                font-style: normal;
                font-weight: 600;
                line-height: 40px;
                letter-spacing: 0em;
                text-align: left;
                background: #F5F8FA;
                color: #6278A3;
                width: 40%;

                border-radius: 4px 4px 0px 0px;
                padding: 0.5rem;
                padding-left: 24px;
            }

            /deep/tbody td {
                font-size: 14px;
                padding: 0.5rem;
                padding-left: 24px;
                font-family: Poppins;
                font-size: 14px;
                font-style: normal;
                color: #6278A3;
                font-weight: 400;
                line-height: 40px;
                letter-spacing: 0em;
                text-align: left;
            }
        }

        .pagination-container {
            background-color: #FFFFFF;
            display: flex;
            flex-flow: row;
            align-content: center;
            alignment: center;
            padding-left: 35%;
        }

        .new-user-button {
            margin-left: 2%;
            background: #207BDD;
            border-radius: 4px;
            border-color: #207BDD;
            font-family: Poppins;
            font-size: 14px;
            font-style: normal;
            font-weight: 600;
            line-height: 21px;
            letter-spacing: 0em;
            text-align: center;

            &:hover {
                background-color: #b5dcb1;
                transition: background-color 0.2s linear;
            }
        }

    }

</style>
